export const SHOW_VIDEO_ACTION = 'app/HomePage/SHOW_VIDEO_ACTION';
